<h4 class="card-title font-medium-1 mb-0 text-uppercase text-bold-600" id="striped-row-layout-icons">
  <span class="primary">{{ data.workplanName }}</span> - Desplazamiento de órden de montaje
</h4>
<small>Selecciona la órden de montaje a desplazar, y luego el destino.</small>
<form novalidate [formGroup]="swapForm" (ngSubmit)="onSwapComplete()" class="form form-horizontal striped-rows ">
  <div class="form-body">

    <div class="form-group row">
      <label class="col-md-3 label-control">Máquina origen</label>
      <div class="col-md-6">
        <div class="position-relative has-icon-right">
          <ng-select [items]="selectableAssemblyOrders"
                      bindLabel="machineName"
                      bindValue="id"
                      labelForId="assemblyOrderOrigin"
                      [multiple]="false"
                      placeholder="Origen"
                      [notFoundText]="'Sin resultados'"
                      formControlName="idOrigin"
                      (change)="onValueChanges()">
          </ng-select>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 label-control">Máquina destino</label>
      <div class="col-md-6">
        <div class="position-relative has-icon-right">
          <ng-select [items]="selectableAssemblyOrders"
                      bindLabel="machineName"
                      bindValue="id"
                      labelForId="assemblyOrderDestination"
                      [multiple]="false"
                      placeholder="Destino"
                      [notFoundText]="'Sin resultados'"
                      formControlName="idDestination"
                      (change)="onValueChanges()">
          </ng-select>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-4 mx-auto">
        <img src="assets/img/ejemplo_swap.png" alt="ejemplo_swap" class="machine-img">
      </div>
    </div>

    <div class="form-actions right">
      <button type="button" class="btn btn-raised btn-grey-custom mr-1" (click)="onCancel()">
        Cancelar
      </button>
      <button type="submit" class="btn btn-raised  btn-success" [disabled]="!swapForm.valid">Guardar</button>
    </div>

  </div>
</form>
